import {
    Component,
    Input
} from '@angular/core';
import {
    ShoppingCart,
    LineItem,
    User,
    Plan,
    Feature,
    FeatureMap,
    FeatureAvailability
} from '../../models';
import * as _ from 'lodash';

@Component({
    selector: 'order-details',
    styles: [require('./order-details.component.scss')],
    template: require('./order-details.component.html')
})
export class OrderDetailsComponent {

    @Input() public shoppingCart: ShoppingCart;
    @Input() public user: User;
    @Input() public total: number;
    @Input() public today: number;

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/components/order/order-details.component.ts